import React from 'react';
import { connect } from 'react-redux';

class FoodItemAddonSelection extends React.Component {

    constructor(props) {
        super(props);

    }

    render() {

        return (
            <div
                className="food-item-addon-selection-window"
            >
                <label className="container" for={"addon-"+this.props.addon.id} >
                {(typeof this.props.children == "string") ? this.props.children : this.props.children.join('')}
                <input
                    type="checkbox"
                    onClick={this.props.onPress}
                    checked={this.props.checked}
                    id={"addon-"+this.props.addon.id}
               
                />
                <span className="checkmark"></span>
                </label>
            </div>
        );
    }
};

export default connect()(FoodItemAddonSelection);